module.exports = __webpack_public_path__ + "static/media/potip.c4f5c936.png";